export const Themes = {
    colors: {
        background: '#EFEFEF',
        primary: '#51151E',
        primaryLighten: '#BF2725',
        primaryText: '#31353E',
        secondary: '#BF2725',
        warning: '#dbcd32',
        success: '#3dcf36',
        info: '#4b99c9',
        danger: '#de5e45',
        none: '#transparent',
        borderSuccess: '#006400',
        borderDanger: '#b54c37',
    },
    textColor: {
        primary: '#FFF',
        secondary: '#FFF',
        warning: '#000',
        success: '#FFF',
        info: '#FFF',
        danger: '#FFF',
        none: '#64696c',
    }
}